import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import { INBOX_FOLDER_NAME, MSG_FOLDER_ROOT } from 'mini-mail-common/lib/utils/folderNameConstants';
import { isFolderTableEmpty } from 'owa-mail-store/lib/utils/isFolderTableEmpty';
import { loadFolders } from 'mini-mail-folder-actions';
import { orchestrator } from 'satcheljs';
import { setCurrentFolderScopeId, setLastSelectedMailFolderId } from '../actions/privateActions';
import { setSelectedFolderId } from 'owa-mail-store/lib/actions/setSelectedFolderId';
import { startMailSearchSession } from '../actions/publicActions';

/**
 * Orchestrator function which initializes the mailQueryParam values in Search Store
 * This is called only once when the search module gets mounted
 */
export default orchestrator(startMailSearchSession, () => {
    /**
     * Store the folderId of the mail folder, from where we've switched to search
     * If the base module was mail, then selectFolder needs to be triggered for this folderId, when exiting search.
     */
    const lastSelectedMailFolderId = getSelectedFolderId() || folderNameToId(MSG_FOLDER_ROOT);
    setLastSelectedMailFolderId(lastSelectedMailFolderId);

    /**
     * Set the selectedFolderId in mailStore as null because of :-
     * Components which rely on getSelectedFolderId() to work with folderIds will cause bugs
     */
    setSelectedFolderId(null);

    /** currentFolderScopeId will be set to All folders , if lastSelectedFolderId is Inbox */
    const currentFolderIdToBeSet =
        lastSelectedMailFolderId !== folderNameToId(INBOX_FOLDER_NAME)
            ? lastSelectedMailFolderId
            : folderNameToId(MSG_FOLDER_ROOT);

    setCurrentFolderScopeId(currentFolderIdToBeSet);

    /**
     * Load mail folders.
     * This should be moved to the common startSearchSession action once the "all tab" is ready
     */
    isFolderTableEmpty() && loadFolders();
});
